import styled from 'styled-components';

export const CardsList = styled.div`
  & > *:last-child {
    margin-bottom: 0;
  }
`;
